import { constants } from '../_constants/conversation.constants';
import { service } from '../_services/conversation.service';

export function updateConversationById(conversation) {
  return { type: constants.CVS_UPDATE_BY_ID, conversation }
}

export function addConversation(conversation) {
  return { type: constants.CVS_CONVERSATION_ADD, conversation}
}

export function clearState() {
  return { type: constants.CVS_INIT_STATE}
}

export function prependMessage(message) {
  return { type: constants.CVS_PREPEND_MESSAGE, message}
}

export function addMessageCollection(message) {
  return { type: constants.CVS_MSG_ADD, message }
} 

export function setConversation(data) {
  return { type: constants.CVS_RETRIEVE_SUCCESS, data }
}

export function loadConversations(params) {
  return dispatch => {
    service.getConversations(params)
      .then((conversations) => {
        dispatch(success(conversations));
      })
      .catch(() => {
        dispatch(failure());
      });
  }

  function success(conversations) { return { type: constants.CVS_ALL_RETRIEVE_SUCCESS, conversations } }
  function failure() { return { type: constants.CVS_ALL_RETRIEVE_FAILURE } }
}

export function getConversations(params) {
  return dispatch => {
    dispatch(request());

    service.getConversations(params)
      .then((conversations) => {
        dispatch(success(conversations));
      })
      .catch(() => {
        dispatch(failure());
      });
  }

  function request() { return { type: constants.CVS_ALL_RETRIEVE_REQUEST } }
  function success(conversations) { return { type: constants.CVS_ALL_RETRIEVE_SUCCESS, conversations } }
  function failure() { return { type: constants.CVS_ALL_RETRIEVE_FAILURE } }
}

export function getConversation(conversationId) {
  return dispatch => {
    dispatch(request());

    service.getConversation(conversationId)
      .then((conversation) => {
        dispatch(success(conversation));
      })
      .catch(() => {
        dispatch(failure());
      });
  }

  function request() { return { type: constants.CVS_RETRIEVE_REQUEST } }
  function success(data) { return { type: constants.CVS_RETRIEVE_SUCCESS, data } }
  function failure() { return { type: constants.CVS_RETRIEVE_FAILURE } }
}

export function retrieveMessages(conversationId) {
  return dispatch => {
    dispatch(request());

    service.retrieveMessages(conversationId)
      .then((messages) => {
        dispatch(success(messages.data));
      })
      .catch(() => {
        dispatch(failure());
      });
  }

  function request() { return { type: constants.CVS_MSG_RETRIEVE_REQUEST } }
  function success(messages) { return { type: constants.CVS_MSG_RETRIEVE_SUCCESS, messages } }
  function failure() { return { type: constants.CVS_MSG_RETRIEVE_FAILURE } }
}